import React from "react";

function CodeComp() {
  return (
    <div className="code-comp">
      <div className="yellow-line width-20"></div>
      <div className="margin-left blue-line width-50"></div>
      <div className="row-comp margin-left">
        <div className="blue-line width-20"></div>
        <div className="dark-blue-line width-50"></div>
        <div className="blue-line width-30"></div>
      </div>
      <div className="yellow-line width-30"></div>
      <div className="margin-left blue-line width-30"></div>
      <div className="yellow-line width-10"></div>
      <div className="row-comp">
        <div className="blue-line width-10 margin-left"></div>
        <div className="dark-blue-line width-20"></div>
        <div className="blue-line width-10"></div>
      </div>
      <div className="dark-blue-line width-20"></div>
      <div className="yellow-line width-10"></div>
      <div className="dark-blue-line width-30 margin-left"></div>
    </div>
  );
}

export default CodeComp;
